import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const APPLICATIONS = [
  { id: 1, name: 'Sarah Wilson', position: 'Senior Designer', date: '2 hours ago', status: 'Pending', avatar: 'https://i.pravatar.cc/150?img=32' },
  { id: 2, name: 'John Doe', position: 'Backend Engineer', date: '5 hours ago', status: 'Reviewed', avatar: 'https://i.pravatar.cc/150?img=12' },
  { id: 3, name: 'Michael Chen', position: 'Product Manager', date: 'Yesterday', status: 'Shortlisted', avatar: 'https://i.pravatar.cc/150?img=53' },
  { id: 4, name: 'Emily Davis', position: 'QA Specialist', date: '2 days ago', status: 'Rejected', avatar: 'https://i.pravatar.cc/150?img=44' },
  { id: 5, name: 'Robert Fox', position: 'DevOps Lead', date: '3 days ago', status: 'Accepted', avatar: 'https://i.pravatar.cc/150?img=68' },
];

const StatusBadge = ({ status }) => {
  const styles = {
    'Pending': 'bg-yellow-50 text-yellow-600',
    'Reviewed': 'bg-blue-50 text-blue-600',
    'Shortlisted': 'bg-brand-primary/10 text-brand-primary',
    'Rejected': 'bg-red-50 text-red-600',
    'Accepted': 'bg-green-50 text-green-600',
  };
  return (
    <span className={`px-2 py-0.5 rounded text-[11px] font-bold uppercase tracking-wider ${styles[status]}`}>
      {status}
    </span>
  );
};

const RecentApplications = () => {
  return (
    <div className="card h-full overflow-hidden">
      <div className="p-6 border-b border-gray-100 flex justify-between items-center">
        <div>
          <h3 className="text-lg font-bold text-gray-800">Recent Applications</h3>
          <p className="text-sm text-gray-500">Track latest candidate submissions</p>
        </div>
        <button className="text-sm text-brand-primary font-medium hover:underline">View History</button>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead className="bg-gray-50/50 text-gray-400 font-semibold uppercase text-[11px] tracking-widest">
            <tr>
              <th className="px-6 py-4">CANDIDATE</th>
              <th className="px-6 py-4">POSITION</th>
              <th className="px-6 py-4">APPLIED</th>
              <th className="px-6 py-4">STATUS</th>
              <th className="px-6 py-4 text-right">ACTION</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {APPLICATIONS.map((app) => (
              <tr key={app.id} className="hover:bg-gray-50/50 transition-colors group">
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <img src={app.avatar} className="w-9 h-9 rounded-full" alt="" />
                    <span className="font-semibold text-gray-800">{app.name}</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-600 font-medium">{app.position}</td>
                <td className="px-6 py-4 text-gray-500">{app.date}</td>
                <td className="px-6 py-4">
                  <StatusBadge status={app.status} />
                </td>
                <td className="px-6 py-4 text-right">
                  <button className="p-1.5 text-gray-400 hover:text-brand-primary hover:bg-white rounded-lg transition-all shadow-sm">
                    <SafeIcon name="Eye" size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentApplications;